// 2px-tall bar pinned to the top of the viewport, tinted with the active
// environment's color. Shares the ["environments", wid] React Query key
// with Topbar so it's free — no extra fetch.
//
// Sits at z-199, just below LoadingBar (z-200). When the loading bar is
// idle (opacity: 0), the env color shows through; when it's active, the
// moving accent bars ride on top of the env color.

import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { readEnvId } from "./Topbar";

export default function EnvBar({ workspaceId }: { workspaceId: string }) {
  const [sp] = useSearchParams();
  const envId = (sp.get("env") ?? "") || readEnvId(workspaceId);
  const envsQ = useQuery({
    queryKey: ["environments", workspaceId],
    queryFn: () => api.environments.list(workspaceId),
  });
  const env = envsQ.data?.environments.find((e) => e.id === envId);
  const color = env?.color ?? null;
  return (
    <div
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[2px] z-[199] pointer-events-none transition-colors duration-150"
      style={{ background: color ?? "transparent" }}
    />
  );
}
